import { useAtom } from 'jotai'

import { submittingFlowFormAtom } from '../submitting-atom'

export const useSubmittingWrapper = () => {
  const [, setSubmitting] = useAtom(submittingFlowFormAtom)

  return async <T>(value: T | Promise<T>): Promise<T> => {
    setSubmitting(true)
    try {
      return await value
    } finally {
      setSubmitting(false)
    }
  }
}
